define(['jQuery'], function ($) {

    /**
     * The main teaser component, having a list on the right and an image
     * section to the left.
     *
     * Note that one instance of TeaserSlider only manages one appearance
     * of such an component; if there are multiple occurrences of a main
     * teaser, use multiple instances of TeaserSlider
     *
     * @param {String} selector The selector to the root node of the component
     * @param {Object} [options] An optional configuration object
     * @constructor
     * @name TeaserSlider
     */
    var TeaserSlider = function (selector, options) {

        // Set root node
        this.rootNode = $(selector);

        // An instance of TeaserSlider handles only one item
        if (this.rootNode.length > 1) {
            this.rootNode = this.rootNode.first();
        }

        // Set options
        var defaultOptions = {

            // The selector to the list container
            listContainerSelector: '[data-fcse-role=teaser-slider-list-container]',

            // The selector to the items inside of the list container
            listItemSelector: '[data-fcse-role=teaser-slider-list-item]',

            // The className to be applied to the highlighted list item
            listItemActiveClassname: 'is-active',

            // The selector to the slideshow container
            slideshowContainerSelector: '[data-fcse-role=teaser-slider-slideshow-container]',

            // The selector to the node carrying an item's slideshow content
            slideshowItemSelector: '[data-fcse-role=teaser-slider-slideshow-item]',

            // The hidden className to remove from a visible slideshow content node
            hiddenClassName: 'is-hidden',

            // The auto-slide interval
            autoSlideInterval: 3000
        };
        this.options = $.extend({}, defaultOptions, options);

        // Startup
        this._init();
    };

    TeaserSlider.prototype = /** @lends TeaserSlider */ {

        /**
         * A reference to the ctor
         *
         * @type {TeaserSlider}
         */
        constructor: TeaserSlider,

        /**
         * The applied options for this instance
         *
         * @type {Object}
         */
        options: null,

        /**
         * The index of the currently highlighted item
         *
         * @type {Number}
         */
        currentItemIndex: 0,

        /**
         * The internally used interval id
         *
         * @type {Number}
         * @private
         */
        _autoSlideIntervalId: null,

        /**
         * Whether there is auto-sliding currently going on
         *
         * @type {Boolean}
         */
        isAutoSliding: null,

        /**
         * Initialises TeaserSlider
         *
         * @private
         */
        _init: function () {

            // Setup ref to slideshow container
            this.slideshowContainer = this.rootNode.find(this.options.slideshowContainerSelector);

            // Setup items
            var items = this.items = [];
            this.rootNode.find(this.options.listItemSelector).each($.proxy(function (index, node) {
                var listNode = $(node),
                    slideshowNode = listNode.find(this.options.slideshowItemSelector)
                        .remove()
                        .removeClass(this.options.hiddenClassName);

                // store item data
                items.push({
                    listNode: listNode,
                    slideshowNode: slideshowNode,
                    index: index
                });

                // connect list node
                listNode.on('mouseenter', $.proxy(function () {
                    this.showItem(index, { stopAutoSlide: true });
                }, this));

            }, this));

            // Pause auto-sliding during user interaction
            this.rootNode.on('mouseleave', $.proxy(this.startAutoSlide, this));
            this.rootNode.on('mouseenter', $.proxy(this.stopAutoSlide, this));

            // Go
            this.showItem(0);
            this.startAutoSlide();
        },

        /**
         * Makes a certain item "active", i.e. highlights it's list node
         * and displays it's slideshow node.
         *
         * @param {Number} index the index of the item to show
         * @param {Object} [options] An optional options object
         * @param {Boolean} [options.stopAutoSlide] If set to true,
         *  auto-sliding will be stopped
         */
        showItem: function (index, options) {
            var itemData = this.items[index],
                highlightClassName = this.options.listItemActiveClassname;

            // stop auto-sliding if the call is coming from a user interaction
            if (options && options.stopAutoSlide) {
                this.stopAutoSlide();
            }

            // remove old highlighting className
            if (itemData && this.items.length) {
                this.items[this.currentItemIndex].listNode.removeClass(highlightClassName);

                // update current item index
                this.currentItemIndex = index;

                // set new highlighting className
                itemData.listNode.addClass(highlightClassName);

                // update slideshow content
                this.slideshowContainer.empty().append(itemData.slideshowNode);
            }
        },

        /**
         * Shows the next item, re-starts with first item if current item is
         * the last one.
         */
        showNext: function () {
            var nextIndex = this.currentItemIndex == this.items.length - 1 ? 0 : this.currentItemIndex + 1;
            this.showItem(nextIndex);
        },

        /**
         * Starts the auto-sliding
         */
        startAutoSlide: function () {
            if (this.isAutoSliding) {
                return;
            }
            this.isAutoSliding = true;

            this._autoSlideIntervalId = setInterval($.proxy(this.showNext, this), this.options.autoSlideInterval);
        },

        /**
         * Stops the auto-sliding.
         */
        stopAutoSlide: function () {
            clearInterval(this._autoSlideIntervalId);
            this.isAutoSliding = false;
        }
    };

    return TeaserSlider;
});



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/teaserslider/teaserSlider.js